import { BaseXHR } from 'utils/axios';

export const getListCategoryApi = () => BaseXHR.$get('category/gets');
